import { Button, Icon, Row, Select, SelectOption } from '@amzn/meridian';
import arrowDownLargeTokens from '@amzn/meridian-tokens/base/icon/arrow-down-large';
import arrowUpLargeTokens from '@amzn/meridian-tokens/base/icon/arrow-up-large';
import type { FC } from 'react';
import type { SortType } from './filters.util';

export type SortSelectorProps = {
  groupBy: string | null;
  sortAsc: boolean;
  sortBy: SortType;
  sortOptions: SortType[];
  onToggleSortDir: () => void;
  onUpdateSortSelection: (sortType: SortType) => void;
};

export const SortSelector: FC<SortSelectorProps> = ({ sortBy, groupBy, onToggleSortDir, onUpdateSortSelection, sortAsc, sortOptions }) => (
  <div>
    <Row alignmentVertical="bottom" spacing="100">
      <Select
        aria-label="Sort campaigns by criteria"
        data-cy="sort-campaigns-by"
        disabled={Boolean(groupBy)}
        id="sort-campaigns-by"
        label="Sort by"
        onChange={onUpdateSortSelection}
        size="small"
        value={sortBy}
      >
        {sortOptions.map((option) => (
          <SelectOption key={option} label={option} value={option}></SelectOption>
        ))}
      </Select>
      <Button data-cy="toggle-sort-dir" disabled={Boolean(groupBy)} onClick={onToggleSortDir} size="small" type="icon">
        <Icon tokens={sortAsc ? arrowDownLargeTokens : arrowUpLargeTokens}>
          {`Change sort direction. Current direction: ${sortAsc ? 'asc' : 'desc'}`}
        </Icon>
      </Button>
    </Row>
  </div>
);
